import abi from './abi'

export const ZoraCreator1155Impl = {
  abi,
} as const
